import { render, staticRenderFns } from "./EditAttribute.vue?vue&type=template&id=6cc7df44"
import script from "./EditAttribute.vue?vue&type=script&lang=js"
export * from "./EditAttribute.vue?vue&type=script&lang=js"
import style0 from "./EditAttribute.vue?vue&type=style&index=0&id=6cc7df44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports